export const routerConstants = {
  PUSH: 'STACK_PUSH',
  POP: 'STACK_POP',
  FLEET: 'FLEET',
  GATEWAY: 'GATEWAY',
  VEHICLE: 'VEHICLE',
  USERS: 'USERS',
  CLEAR: 'STACK_CLEAR',
}
